import { Component } from '@angular/core';

import { AuthService } from '@app/shared/services/auth.service';
import { UserManager } from '@app/shared/services/user-manager.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  standalone: false
})
export class NotFoundComponent {
  isLoggedIn = this.userManager.isLoggedIn;
  loginLink = this.Auth.LOGIN_LINK;

  constructor(
    private Auth: AuthService,
    private userManager: UserManager
  ) {}
}
